module.exports = __webpack_public_path__ + "static/img/category_20.9ad1064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_20.jpg
// module id = 62ON
// module chunks = 0